import { css } from 'lit';
export default css `
  h1 {
    margin: 0;
    padding: 0;
    font-size: 24px;
    line-height: 32px;
    font-weight: 700;
  }
`;
//# sourceMappingURL=styles.js.map